class _MockContractService {
  fetchMockContract() {
    const res = {
      byteInputStream: [],
      byteInputStreamShipLbl: [],
    };
    return res;
  }

  fetchMockContractDetails() {
    const res = {
      contractByteArray: [],
      documentByteArray: [],
      hasCoBorrower: true,
      contractDetails: {
        firstName: 'John',
        principalOwed: '25230',
        contractTerm: '48',
        monthlyPayment: '595',
        paymentDay: '19th',
        titleFee: '100',
        loanInterestRate: '5.99',
        financeCharge: '3231.17',
        amountFinanced: '25330.00',
        totalLoanCost: '28661.17',
        vehicleInfo: {
          vin: 'X1B0123456789B',
          year: '2021',
          make: 'Land Rover',
          model: 'Range Rover Evoque 2.0',
        },
      },
    };
    return res;
  }
}

export const MockContractService = new _MockContractService();
